/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop as MuiBackdrop, CircularProgress } from '@material-ui/core';
import { useApplication } from '../../redux/features/application/useApplication';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 200,
    color: '#fff',
  },
}));

export default function Backdrop({ blocking }) {
  const classes = useStyles();
  const { loading } = useApplication();

  return (
    <MuiBackdrop className={classes.backdrop} open={blocking || loading || false} aria-label="backdrop">
      <CircularProgress color="inherit" data-testid="loading" />
    </MuiBackdrop>
  );
}
